'use client';
import { Sidebar } from '@/components/sidebar/sidebar';
import { SidebarProvider } from '@bells/ui/components/sidebar';

import BottomIcons from '@/components/layouts/bottom-icons';
import type { Locale } from '@bells/i18n/runtime';
import { type NavigationItemTransform } from '@bells/ui/utils/navigation';

export default function SidebarLayout({
  children,
  defaultOpen,
  navItems,
  lng,
}: Readonly<{
  children: React.ReactNode;
  defaultOpen?: boolean;
  lng: Locale;
  navItems?: NavigationItemTransform[];
}>) {
  return (
    <>
      <SidebarProvider
        defaultOpen={false}
        mobileBreakpoint={1024}
        sidebarWidth={'250px'}
      >
        <Sidebar navigation={navItems ?? []} locale={lng}>
          {children}
        </Sidebar>
        <BottomIcons></BottomIcons>
      </SidebarProvider>
    </>
  );
}
